import React, { useCallback } from 'react'
import styled from 'styled-components'
import { IPalletDetails } from '../../../../modules/API/Pallets/models/palletDetails'
import CardFlat from '../../../ui/card-flat/CardFlat'
import ProductImage from '../../../../main/second/mainbar/queries/TeudotDetails/Components/ProductImage'
import SproutIcon from '../../../icons/IconLib/SproutIcon'
import PackageBoxIcon from '../../../icons/IconLib/PackageBoxIcon'
import BoxesIcon from '../../../icons/IconLib/BoxesIcon'

type Props = {
  item: IPalletDetails
  quantity: number
  onChange: (recID: number, qty: number) => void
}

const CardInner = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 0.8em;
  width: 100%;
  direction: rtl;
`

const ImageWrapper = styled.div`
  flex-shrink: 0;
  width: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const InfoWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.4em;
`

const QtyWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5em;
  direction: rtl;
  margin-top: 0.2em;
`

const QtyLabel = styled.span`
  font-size: 0.72rem;
  color: #8a9ab0;
  font-weight: 500;
  white-space: nowrap;
`

const QtyInput = styled.input`
  width: 72px;
  padding: 0.3em 0.5em;
  border: 1.5px solid #c8d4de;
  border-radius: 8px;
  font-size: 0.88rem;
  font-weight: 600;
  color: #1e2d3d;
  text-align: center;
  outline: none;
  direction: ltr;

  &:focus {
    border-color: #297f76;
  }
`

const ProductCard = ({ item, quantity, onChange }: Props) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const raw = parseFloat(e.target.value)
      const clamped = isNaN(raw) ? 0 : Math.min(Math.max(raw, 0), item.Quantity)
      onChange(item.RecID, clamped)
    },
    [item.RecID, item.Quantity, onChange]
  )

  return (
    <CardFlat.Root>
      <CardInner>
        <ImageWrapper>
          <ProductImage id={item.GeneralProductID} size="sm" />
        </ImageWrapper>
        <InfoWrapper>
          <CardFlat.Row>
            <CardFlat.Item>
              <CardFlat.ItemIcon>
                <SproutIcon size={13} color='currentColor' />
              </CardFlat.ItemIcon>
              <CardFlat.ItemValue>{`${item.ProductDesc.trim()} ${item.VarietyDesc.trim()} ${item.SizeID.trim()}`}</CardFlat.ItemValue>
            </CardFlat.Item>
          </CardFlat.Row>
          <CardFlat.Divider />
          <CardFlat.Row>
            <CardFlat.Item>
              <CardFlat.ItemIcon>
                <PackageBoxIcon size={13} color='currentColor' />
              </CardFlat.ItemIcon>
              <CardFlat.ItemLabel>אריזה</CardFlat.ItemLabel>
              <CardFlat.ItemValue>{item.Pack_Name.trim()}</CardFlat.ItemValue>
            </CardFlat.Item>
            <CardFlat.Item>
              <CardFlat.ItemIcon>
                <BoxesIcon size={13} color='currentColor' />
              </CardFlat.ItemIcon>
              <CardFlat.ItemLabel>כמות בתעודה</CardFlat.ItemLabel>
              <CardFlat.ItemValue>{item.Quantity}</CardFlat.ItemValue>
            </CardFlat.Item>
          </CardFlat.Row>
          <QtyWrapper>
            <QtyLabel>כמות להעברה:</QtyLabel>
            <QtyInput
              type="number"
              min={0}
              max={item.Quantity}
              step={1}
              value={quantity === 0 ? '' : quantity}
              placeholder="0"
              aria-label={`כמות להעברה עבור ${item.ProductDesc.trim()}`}
              onChange={handleChange}
            />
          </QtyWrapper>
        </InfoWrapper>
      </CardInner>
    </CardFlat.Root>
  )
}

export default ProductCard
